import { render } from "./EventTable.vue?vue&type=template&id=f64aae90&scoped=true"
import script from "./EventTable.vue?vue&type=script&lang=js"
export * from "./EventTable.vue?vue&type=script&lang=js"

import "./EventTable.vue?vue&type=style&index=0&id=f64aae90&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f64aae90"]])

export default __exports__